// extracted by mini-css-extract-plugin
export var body = "_p6-8";
export var button = "_p6-0";
export var closeButton = "_p6-5";
export var content = "_p6-3";
export var empty = "_p6-f";
export var grid = "_p6-c";
export var header = "_p6-4";
export var icon = "_p6-1";
export var option = "_p6-d";
export var optionSelected = "_p6-e";
export var overlay = "_p6-2";
export var searchIcon = "_p6-a";
export var searchInput = "_p6-b";
export var searchWrapper = "_p6-9";
export var title = "_p6-6";
export var visuallyHidden = "_p6-7";